import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "5.5",
  width: "28",
  height: "4.2",
  rx: "2.1",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "13.90002",
  width: "28",
  height: "4.2",
  rx: "2.1",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "22.3",
  width: "28",
  height: "4.2",
  rx: "2.1",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }